/* eslint-disable import/prefer-default-export */
export const GET_RELOCATION_REQUEST = 'GET_RELOCATION_REQUEST';
